<template>
  <div>
    <h1 class="text-center font-extrabold text-xl">Modification de l'entit&eacute; de facturation</h1>
    <BillingEntityForm v-model="formData" :stores="stores" :showIban="true" @submit="submit" />
  </div>
</template>

<script>
import BillingEntityForm from "@/components/billing_entities/BillingEntityForm.vue";
import { mapActions } from "vuex";

export default {
  components: {
    BillingEntityForm,
  },
  props: {
    billingEntity: {
      type: Object,
      required: true,
    },
    stores: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["success"],
  data() {
    return {
      formData: {
        name: this.billingEntity.name,
        businessName: this.billingEntity.businessName,
        billingAddress: this.billingEntity.billingAddress,
        iban: this.billingEntity.iban,
        storeIds: this.billingEntity.stores?.map((s) => s.id) || [],
      },
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("billingEntities", ["update"]),

    async submit() {
      const result = await this.update({
        id: this.billingEntity.id,
        ...this.formData,
      });
      if (!result) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Entit\u00e9 de facturation mise \u00e0 jour",
      });
      this.$emit("success");
    },
  },
};
</script>
